import React from 'react';
import { bool, shape, string } from 'prop-types';

const VisibilityOff = ({
  className = 'icon',
  notUseClass = false,
  color = '#696f88',
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={{ color, ...style }} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M4.69 6.52578L2.01 3.84578L3.42 2.42578L21.15 20.1658L19.74 21.5758L16.32 18.1558C14.98 18.6858 13.52 18.9758 12 18.9758C7 18.9758 2.73 15.8658 1 11.4758C1.77 9.50578 3.06 7.80578 4.69 6.52578ZM12.0004 5.97656C15.7904 5.97656 19.1704 8.10656 20.8204 11.4766C20.2304 12.6966 19.4004 13.7466 18.4104 14.5966L19.8204 16.0066C21.2104 14.7766 22.3104 13.2366 23.0004 11.4766C21.2704 7.08656 17.0004 3.97656 12.0004 3.97656C10.7304 3.97656 9.51035 4.17656 8.36035 4.54656L10.0104 6.19656C10.6604 6.06656 11.3204 5.97656 12.0004 5.97656ZM10.9297 7.11656L12.9997 9.18656C13.5697 9.43656 14.0297 9.89656 14.2797 10.4666L16.3497 12.5366C16.4297 12.1966 16.4897 11.8366 16.4897 11.4666C16.4997 8.98656 14.4797 6.97656 11.9997 6.97656C11.6297 6.97656 11.2797 7.02656 10.9297 7.11656ZM9.51 11.3477L12.12 13.9577C12.08 13.9677 12.04 13.9777 12 13.9777C10.62 13.9777 9.5 12.8577 9.5 11.4777C9.5 11.4527 9.5025 11.4327 9.505 11.4127C9.5075 11.3927 9.51 11.3726 9.51 11.3477ZM7.85969 9.69531L6.10969 7.94531C4.89969 8.86531 3.87969 10.0453 3.17969 11.4753C4.82969 14.8453 8.20969 16.9753 11.9997 16.9753C12.9497 16.9753 13.8697 16.8353 14.7497 16.5953L13.7697 15.6153C13.2297 15.8453 12.6297 15.9753 11.9997 15.9753C9.51969 15.9753 7.49969 13.9553 7.49969 11.4753C7.49969 10.8453 7.62969 10.2453 7.85969 9.69531Z" fill="currentColor" />
  </svg>
);

VisibilityOff.propTypes = {
  className: string,
  notUseClass: bool,
  color: string,
  style: shape({}),
};

export default VisibilityOff;
